import { useQuery } from 'react-query'

import { scanService } from 'src/services/scan.service'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'

export const initialFilter = {
  accountsIds: ['all'],
}

export const useScansStatusCount = ({
  filter,
  isScanner,
}: {
  filter: { accountsIds: string[] }
  isScanner: boolean
}) => {
  return useQuery(
    [QUERY_KEYS.SCANS_STATUS_COUNT, filter],
    () => scanService.getScansStatusCount(removeDefaultParams(filter, initialFilter), isScanner),
    {},
  )
}
